module.exports = __webpack_public_path__ + "img/beijing12.85bddc94.png";